import React from 'react'
import { Box } from '@node-space/ui-components'

export const CardDetailsInfoSkeleton: React.FC = () => (
  <Box aria-label="card-details-skeleton" flexCol gapY={8} paddingY={4}>
    <Box className="h-5 w-64 rounded bg-surface-static animate-pulse" />
    <Box className="h-8 w-40 rounded bg-surface-static animate-pulse" />
    <Box className="h-6 w-28 rounded bg-surface-static animate-pulse" />
  </Box>
)
